'use client';

/**
 * Users end up here if they request an unknown endpoint/page
 *
 * @packageDocumentation
 * @category Page
 */

import moduleStyles from 'Workadabra/app/[lang]/not-found.module.css';
import { Button, Section } from '@bomdisoft/components';
import { getLanguageFromLocale, returnHome } from '@bomdisoft/translations';
import { useParams, useRouter } from 'next/navigation';

const NotFound = () => {
  const params = useParams<{ lang: string }>();
  const language = getLanguageFromLocale(params.lang);
  const router = useRouter();

  return (
    <Section className={moduleStyles.section}>
      <Button onClick={() => router.push('/')} variant='contained'>
        {returnHome[language]}
      </Button>
    </Section>
  );
};

export default NotFound;
